import React, { useState, useEffect } from "react";
//语言切换
import intl from "react-intl-universal";
import { LeftOutlined } from "@ant-design/icons";
import { Button, Col, message, Row } from "antd";
import { cloneDeep } from "lodash";
import Question from "../components/question";
import "./createQuestion.less";
import { createQuestion } from "../../../../services/question";
import { getSign } from "../../../../services/auth";
import { useParams } from "react-router-dom/cjs/react-router-dom.min.js";
import en_US from "@/locales/en_US/index.json";
import zh_CN from "@/locales/zh_CN/index.json";
import uploadImg from "@/assets/submit.png";
const locales = {
  en_US,
  zh_CN,
};

//创建传统题目页
function CreateQuestion(props) {
  const [dataSource, setDataSource] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(dataSource[0]);
  const routerParams = useParams();
  const [OSSData, setOSSData] = useState();
  const initInfo = {
    index: 1,
    title: intl.get("afb85f19-3e7b-28cf-af4e-41c5b700e8b2"), //标题
    type: 1, //1单选，2多选，3判断，4填空，5简答
    options: [
      {
        title: `${intl.get("132f6300-dcef-2be4-9b80-88d645bec64b")}1`, //选项1
        value: 1,
      },
      {
        title: `${intl.get("132f6300-dcef-2be4-9b80-88d645bec64b")}2`, //选项2
        value: 2,
      },
    ],
  };
  useEffect(() => {
    intl
      .init({
        currentLocale: localStorage.getItem("language_type") || "zh_CN",
        locales,
      })
      .then(() => {});
    if (!OSSData) {
      init();
    }
  }, [dataSource]);

  // 初始化
  const init = async () => {
    try {
      const res = await getSign("exam", "questionRepo"); // 题库资源获取签名
      if (res.code === 0) {
        setOSSData(res.data);
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error(error);
    }
  };

  //返回题库列表
  const backToList = () => {
    props.history.push(
      `/admin/train/questionManage/list/${routerParams.productionId}`
    );
  };

  //题目数据发生变化,删除,修改等
  const changeQuestion = (index, operateType, key, value) => {
    const data = cloneDeep(dataSource);
    if (operateType === "delete") {
      data.splice(index, 1);
    } else if (operateType === "change") {
      if (key === "type") {
        //清除复选框全选状态,以防切换为单选时按钮切换事件失效
        data[index].options.map((option) => (option.correctAnswer = 0));
      }
      data[index][key] = value;
    }
    setDataSource(data);
  };

  //渲染题目列表
  const renderQuestionList = () => {
    return dataSource.map((data, index) => {
      return (
        <Question
          canEdit={currentQuestion.index === data.index}
          key={`question-${dataSource.length}-${index}`}
          index={index}
          data={data}
          ossData={OSSData}
          status={"add"}
          changeEditStatus={(item) => {
            setCurrentQuestion(item);
          }}
          changeQuestion={changeQuestion}
        />
      );
    });
  };

  //添加题目
  const addQuestion = () => {
    const data = [...dataSource];
    //用作唯一ID,不使用data.length是为了防止删除后，index出现重复情况
    initInfo.index = data.length > 0 ? data[data.length - 1].index + 1 : 1;
    data.push(JSON.parse(JSON.stringify(initInfo)));
    setDataSource(data);
    setCurrentQuestion(data[data.length - 1]);
  };

  //提交题目列表
  const submitQuestion = () => {
    //判断各题必填项
    const scoreList = [];
    const answerList = [];
    dataSource.map((data, i) => {
      if (!data.score) {
        scoreList.push(i + 1);
      }
      const isCorrectAnswer =
        (data.options || []).filter((option) => option.correctAnswer === 1)
          .length > 0;
      if (!isCorrectAnswer) {
        answerList.push(i + 1);
      }
    });
    if (scoreList.length === 0 && answerList.length === 0) {
      createQuestion({ id: routerParams.id, questions: dataSource }).then(
        (res) => {
          if (res && res.code === 0) {
            props.history.push(
              `/admin/train/questionManage/list/${routerParams.productionId}`
            );
          }
        }
      );
    } else {
      if (answerList.length > 0) {
        message.warn(
          intl.get("98bc06b6-3b77-284d-91c1-8836f838ee62", {
            index: answerList.join(","),
          })
        );
      }
      if (scoreList.length > 0) {
        message.warn(
          intl.get("26c34a87-a146-22e1-a816-efd0cb10d195", {
            index: scoreList.join(","),
          })
        );
      }
    }
  };

  //点击预览事件处理
  const handlePreviewEvent = () => {
    //判断是否有题目
    if (dataSource.length > 0) {
      localStorage.setItem("previewQuestionInfo", JSON.stringify(dataSource));
      window.open("/previewQuestion");
    } else {
      message.warn(intl.get("772b6cda-7f74-2acb-82f0-08c623e2d740"));
    }
  };

  return (
    <div className="createQuestionWrapper">
      <Row className="menuWrap" justify={"space-between"}>
        <Col span={18}>
          <b>{intl.get("b5b7a381-b90e-2e6f-88e3-f2213245acf4")}</b>
        </Col>
        <Col span={6} className="alignEnd">
          <span className="clickBtn" onClick={handlePreviewEvent}>
            {intl.get("43d28447-da41-24b3-9545-8a9e6d871a0d")}
          </span>
          <span className="primaryBtn" onClick={submitQuestion}>
            <img src={uploadImg} className="mr5" />
            {intl.get("Submit_b4c78c66-cc86-21f2-9581-710c4b1acf9b")}
          </span>
        </Col>
      </Row>
      <div className="questionListWrap">
        <h3 className="alignCenter">
          <b>{intl.get("b5b7a381-b90e-2e6f-88e3-f2213245acf4")}</b>
        </h3>
        <div className="questionContent">
          {/* <div className="questionList"> */}
          {renderQuestionList()}
          {/* </div> */}
          <div className="addBtn fs16 clickStyle" onClick={addQuestion}>
            <b>{intl.get("9995042c-e78e-24b5-8582-b98144b89643")}</b>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CreateQuestion;
